// @flow
import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import { Grid, Column } from '../Layout';
import { Heading } from '../Text';
import { ArrowLink } from '../ArrowLink';
import type { MenuStructure } from './Menu';

const Container = styled.div`
  display: flex;
  width: inherit;
  flex-direction: column;
  width: 100%;
  top: 5.25em;
`;

const MenuBarContainer = styled.div`
  background-color: #ffffff;
  display: inline-block;
  flex-direction: row;
  justify-content: space-between;
  height: 3em;
  align-items: center;
`;

const MenuTitles = styled.ul`
  flex-direction: row;
  list-style-type: none;
  margin: 0;
  height: inherit;
  padding: 0;
`;

const MenuLine = styled.li`
  display: inline;
  font-weight: bold;
  padding-right: 1.5em;
  font-family: 'DanskeTextv2';
  height: 100%;
`;

const MenuButton = styled.button`
  background: none;
  border: none;
  font-weight: bold;
  font-size: large;
  font-family: 'DanskeTextv2';
  margin: 0;
  padding: 0;
  height: 100%;
  outline: none;
  outline-offset: 0;
  box-sizing: border-box;
  display: inline-block;
  color: #003755;
  color: ${(props) =>
    props.selected === false && props.anySelected !== null
      ? 'rgba(0, 55, 85, 0.2)'
      : '#003755'};
  ${MenuBarContainer}:hover & {
    color: #003755;
  }
  ${MenuLine}:hover & {
    color: #009edd;
  }
  &:active {
    color: ${(props) =>
      props.selected &&
      css`
        color: rgba(0, 55, 85, 1);
      `};
  }
  vertical-align: bottom;
`;

const MenuContentContainer = styled.div`
  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  background-color: #fbfdfe;
  border: solid 1px #dbe0de;
  border-radius: 2px;
  position: absolute;
  left: 0;
  top: inherit;
  z-index: 901;
  margin: auto;
  opacity: ${(props) => (props.visible ? 1 : 0)};
  transform: scaleY(${(props) => (props.visible ? '1' : '0')});
  transform-origin: top center;
  transition: transform 0.2s ease;
`;

const LinkList = styled.ul`
  padding: 0;
  list-style-type: none;
`;

const Cover = styled.div`
  z-index: 900;
  position: absolute;
  top: inherit;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: table-column;
  height: 100vh;
  transition: opacity 0.2s ease;
`;

const ListContainer = styled(Column)`
  display: flex;
  flex-basis: auto;
`;

const Content = styled(Grid)`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin: auto;
  margin-top: 2.75em;
  padding-bottom: 3.75em;
  opacity: ${(props) => (props.visible ? 1 : 0)};
  transition: opacity 1.5s ease;
`;

const StyledLine = styled.li`
  list-style-type: none;
  list-style-position: inside;
  margin: 0;
  padding: 0;
  text-align: left;
  width: inherit;
  padding-bottom: 0.5em;
`;

const StyledArrowLink = styled(ArrowLink)`
  color: #003755;
`;

type Props = {
  menuData: MenuStructure,
};

type State = {
  selectedMenuContent: any,
  visible: boolean,
};

export class MenuBig extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      selectedMenuContent: null,
      visible: false,
    };
  }

  onSelectMenu = (menuToShow: Object) => {
    if (this.state.selectedMenuContent === menuToShow) {
      this.setState({ selectedMenuContent: null, visible: false });
    } else {
      this.setState({ selectedMenuContent: menuToShow, visible: true });
    }
  };

  onCoverClick = () => {
    this.setState({ selectedMenuContent: null, visible: false });
  };

  renderMenuTitles = () => {
    return this.props.menuData.menuContent.map((menuContent, index) => (
      <MenuLine key={index}>
        <MenuButton
          selected={menuContent === this.state.selectedMenuContent}
          anySelected={this.state.selectedMenuContent}
          onClick={this.onSelectMenu.bind(this, menuContent)}
        >
          {menuContent.menuItemTitle}
        </MenuButton>
      </MenuLine>
    ));
  };

  renderMenuItemContent = (menuContent: Object) => {
    return menuContent.menuItems.map((menuItem) => (
      <ListContainer medium={4} large={3} key={menuItem.title}>
        <Heading>{menuItem.title}</Heading>
        <LinkList>{this.renderContentLinks(menuItem)}</LinkList>
      </ListContainer>
    ));
  };

  renderContentLinks = (menuItem: Object) => {
    return menuItem.links.map((link, index) => (
      <StyledLine key={index}>
        <StyledArrowLink
          id={link.linkTitle}
          to={link.url}
          text={link.linkTitle}
        />
      </StyledLine>
    ));
  };

  render() {
    return (
      <Container>
        <MenuBarContainer>
          <MenuTitles>{this.renderMenuTitles()}</MenuTitles>
        </MenuBarContainer>
        <MenuContentContainer visible={this.state.visible}>
          <Content visible={this.state.visible}>
            {this.state.visible
              ? this.renderMenuItemContent(this.state.selectedMenuContent)
              : null}
          </Content>
        </MenuContentContainer>
        {this.state.visible && <Cover onClick={this.onCoverClick} />}
      </Container>
    );
  }
}

export default MenuBig;
